/*  Shared  */
import { Requests } from 'application/Shared/Requests';

/*  NPM  */
import axios from 'axios';

/*  React  */
import React, { Component } from 'react';
import { withRouter } from 'router/withRouter';

/*  Components  */
import ObjectPicker from './Components/ObjectPicker';

class GroupPicker extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loaded: false,
            objectPayload: []
        };

        /* requests */
        this.requests = new Requests();
    }

    async componentDidMount() {
        let groupResponse;
        const { match } = this.props;
        const { clientId } = match.params;

        try {
            groupResponse = await axios.get('/tenantGroup/', {
                params: {
                    excluded: false,
                    platformTenantId: clientId,
                    size: -1
                }
            });
        } catch (e) {
            return;
        }

        // response has length, so I will assume it is an array
        const augmentedData = groupResponse.data.data.map((group) => ({
            ...group,
            name: `${group.name} (${group.userCount} active users)`
        }));

        this.setState({
            loaded: true,
            objectPayload: augmentedData
        });
    }

    componentWillUnmount() {
        this.unload();
    }

    unload = () => {
        this.requests.cancel();
    };

    render() {
        const { loaded, objectPayload } = this.state;
        return (
            loaded && (
                <ObjectPicker
                    {...this.props}
                    objectPayload={objectPayload}
                    objectNameField="name"
                />
            )
        );
    }
}

export default withRouter(GroupPicker);
